import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let design = class design extends Vue {
    render(h) {
        return h("a-button", "选择");
    }
};
tslib_1.__decorate([
    Prop()
], design.prototype, "control", void 0);
design = tslib_1.__decorate([
    Component({ name: "design" })
], design);
export default design;
